module.exports = __webpack_public_path__ + "img/Umb30_uv_logoend_5460.aee94484.svg";